"use client"

import { Headphones, Lock, Shield, ShieldAlert, Vault } from "lucide-react"

import { SectionContainer } from "@shared/ui/landing/section-container"

import { securityFeatures } from "@/lib/live-data"
import { useTranslations } from "@/lib/i18n/client"

const featureIcons = {
  coldStorage: Vault,
  encryption: Lock,
  antiFraud: ShieldAlert,
  support: Headphones,
  insurance: Shield,
} as const

export function SecuritySection() {
  const t = useTranslations("security")

  return (
    <SectionContainer id="security" className="bg-brand-light/30">
      <div className="text-center">
        <h2 className="text-3xl font-bold text-brand">{t("title")}</h2>
        <p className="mt-3 text-muted-foreground">{t("subtitle")}</p>
      </div>

      <div className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {securityFeatures.map((feature) => {
          const Icon = featureIcons[feature]
          return (
            <div
              key={feature}
              className="rounded-2xl border border-brand bg-white p-6 shadow-sm"
            >
              <div className="flex size-12 items-center justify-center rounded-xl bg-brand/10">
                <Icon className="size-6 text-brand" />
              </div>
              <h3 className="mt-4 text-base font-semibold text-brand">
                {t(`${feature}.title`)}
              </h3>
              <p className="mt-2 text-sm text-muted-foreground">
                {t(`${feature}.description`)}
              </p>
            </div>
          )
        })}
      </div>
    </SectionContainer>
  )
}
